import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

import { Container, Typography, Card, CardContent, CircularProgress } from "@mui/material";

const ViewGift = () => {
  const { id } = useParams();  // ✅ Get gift ID from URL
  const [gift, setGift] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchGiftData = async () => {
      try {
        if (!id) {
          setError("Invalid Gift ID");
          setLoading(false);
          return;
        }

        console.log("Fetching gift ID:", id);  // ✅ Debugging

        const docRef = doc(db, "gifts", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setGift(docSnap.data());
        } else {
          setError("Gift not found!");
        }
      } catch (err) {
        setError("Error fetching gift details");
        console.error("Firestore error:", err);
      }
      setLoading(false);
    };

    fetchGiftData();
  }, [id]);

  return (
    <Container sx={{ mt: 5, display: "flex", justifyContent: "center" }}>
      <Card sx={{ p: 3, backgroundColor: "#121212", color: "#fff", maxWidth: "500px" }}>
        <CardContent>
          <Typography variant="h4" color="primary" fontWeight="bold" textAlign="center">
            🎁 Your Special Gift 🎁
          </Typography>

          {loading ? (
            <CircularProgress color="primary" sx={{ mt: 2, display: "block", mx: "auto" }} />
          ) : error ? (
            <Typography variant="body1" color="error" sx={{ mt: 2, textAlign: "center" }}>
              {error}
            </Typography>
          ) : (
            <>
              <Typography variant="body1" sx={{ mt: 2, textAlign: "center" }}>
                {gift?.message || "No message available"}
              </Typography>

              {gift?.imageUrl && (
                <img
                  src={gift.imageUrl}
                  alt="Gift"
                  style={{
                    width: "100%",
                    maxWidth: "400px",
                    borderRadius: "10px",
                    marginTop: "20px",
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                  loading="lazy"
                />
              )}
            </>
          )}
        </CardContent>
      </Card>
    </Container>
  );
};

export default ViewGift;
